import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LazyLoadScriptService } from './../sidebar/lazy-load-script.service'
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-client',
    templateUrl: './client.component.html',
    styleUrls: ['./client.component.css']
})

export class ClientComponent implements OnInit {
    imageoneClient: boolean = false;
    pageTitle: string;
    pageDisplay: string;

    constructor(
        private activatedroute: ActivatedRoute,
        private router: Router,
        private lazyLoadService: LazyLoadScriptService
    ) { }

    ngOnInit(): void {
        var applicationName = "clientsappelement";

        this.lazyLoadService.loadScript(environment["CLIENTAPPURL"], applicationName).subscribe(_ => {
            let url = this.router.url;
            if (url == '/client/add') {
                this.pageTitle = "New Client";
                this.pageDisplay = "clientAdd";
            } else if (url == '/clients') {
                this.pageTitle = "Clients List";
                this.pageDisplay = "clientList";
            } else if (url == '/clients/map') {
                this.pageTitle = "Clients Map";
                this.pageDisplay = "clientMap";
            } else if (url.includes('/client/edit')) {
                this.pageTitle = "Edit Client";
                this.pageDisplay = "clientEdit";
            } else if (url == '/servicelocations') {
                this.pageTitle = "Service Locations";
                this.pageDisplay = "servicelocationsall";
            } else if (url == '/servicelocations/printQRCodes') {
                this.pageTitle = "Service Locations QR Codes";
                this.pageDisplay = "servicelocationsprintQRCodes";
            } else if (url == '/servicelocations/export/all' || url == '/servicelocations/export/mine') {
                this.pageTitle = "Export Location";
                this.pageDisplay = "servicelocationsallexport";
            } else if (url == '/servicelocations/inactive') {
                this.pageTitle = "Inactive Service Locations";
                this.pageDisplay = "servicelocationsInactive";
            } else if (url == '/servicelocations/inactive/export') {
                this.pageTitle = "Export Inactive Location";
                this.pageDisplay = "servicelocationsInactiveExport";
            } else if (url == '/client/import') {
                this.pageTitle = "Import Client";
                this.pageDisplay = "clientImport";
            } else if (url.includes('/client/servicelocations/add')) {
                this.pageTitle = "Create Service Location";
                this.pageDisplay = "addServiceLocation";
            } else if (url.includes('/client/servicelocations/edit')) {
                this.pageTitle = "Edit Service Location";
                this.pageDisplay = "editServiceLocation";
            } else if (url.includes('/client/servicelocations')) {
                this.pageTitle = "Service Locations";
                this.pageDisplay = "servicelocations";
            } else if (url == '/clients/export') {
                this.pageTitle = "Export Client";
                this.pageDisplay = "exportClient";
            } else if (url == '/clientsinactive/export') {
                this.pageTitle = "Export Inactive Client";
                this.pageDisplay = "exportInactiveClient";
            } else if (url.includes('/clientsinactive')) {
                this.pageTitle = "Inactive Clients List";
                this.pageDisplay = "inactiveClientList";
            } else if (url == '/manageoperation') {
                this.pageTitle = "Manage Operations Person";
                this.pageDisplay = "manageoperation";
            } else if (url.includes('/myLocations/details/show')) {
                this.pageTitle = "Locations Details";
                this.pageDisplay = "myLocationsDetails";
            } else if (url == '/myLocations') {
                this.pageTitle = "Locations";
                this.pageDisplay = "myLocations";
            } else if (url.includes('/inspections/details/show')) {
                this.pageTitle = "Client Inspections Details";
                this.pageDisplay = "inspectionsDetails";
            } else if (url == '/inspections') {
                this.pageTitle = "Client Inspections";
                this.pageDisplay = "inspections";
            } else if (url == '/documents') {
                this.pageTitle = "My Documents";
                this.pageDisplay = "documents";
            } else if (url == '/contacts') {
                this.pageTitle = "Your Team";
                this.pageDisplay = "contacts";
            }else if (url == '/payments') {
                this.pageTitle = "Payment History";
                this.pageDisplay = "paymenthistory";
            } else if (url.includes('/supplies')) {
                console.log('url', url);
                this.pageTitle = "Supplies 23";
                this.pageDisplay = "supplies";
            }
            console.info('Page Display:',this.pageDisplay);
            this.imageoneClient = true;
        });

    }

    ngOnDestroy(): void {
        this.imageoneClient = false;
    }
}